import AxiosApiInstance, {APIBase} from "../AxiosApiInstance";
import {AxiosResponse} from "axios";
import DefaultGetRequest from "../DefaultGetRequest";
import ApiApplicationRenderedModel from "./ApiApplicationRenderedModel";

export const ApiApplicationIdRenderedGet: (id:string, params?: DefaultGetRequest) => Promise<AxiosResponse<ApiApplicationRenderedModel>> = (id, params) => {
  return AxiosApiInstance.get(APIBase + `applications/${id}/rendered/`, {
    params: params
  });
};